import React from 'react';
import logo from 'assets/icons/global/logo.svg';
import Image from 'atomic/image';

import './navigation.scss';
import Icon from 'atomic/icon';

interface NavigationProsp {
    onToggle: () => void;
    isOpen: boolean;
}

const Navigation: React.FC<NavigationProsp> = props => (
    <nav className="navi">
        <a href="/" className="navi__logo" rel="start"
            aria-label="logo" title="Przejdź na stronę główną Skąpiec.pl"
        >
            <Image src={logo} alt="Skąpiec logo" width={132}
                height={28} show={true} loading={'eager'}
            />
        </a>

        {/* eslint-disable-next-line @typescript-eslint/explicit-function-return-type */}
        <div className="navi__btn" role="button" onClick={() => props.onToggle()}>
            <Icon className="navi__btn-icon" name="burger" size={20}
                color="white"
            />
            Kategorie
            {props.isOpen && <div className="navi__btn-arrow"/>}
        </div>
    </nav>
);

export default Navigation;
